<template>
    <v-navigation-drawer v-model="drawer" temporary>
        <v-list-item class="head"><b>Overview</b></v-list-item>
        <v-divider></v-divider>
        <v-list >
          <v-list-item to="/" @click="closeDrawer">{{ $t('message.home') }}</v-list-item>
          <v-list-group value="Tutorials">
            <template v-slot:activator="{ props }">
              <v-list-item
                  v-bind="props"
              > {{ $t('message.tutorials') }}</v-list-item>
            </template>
            <v-list-item to="/tutorials-video" @click="closeDrawer">
              <v-list-item-title >{{ $t('message.video') }}</v-list-item-title>
            </v-list-item>
            <v-list-item to="/tutorials-web" @click="closeDrawer">
              <v-list-item-title>{{ $t('message.web') }}</v-list-item-title>
            </v-list-item>
            <v-list-item to="/tutorials-r" @click="closeDrawer">
              <v-list-item-title>{{ $t('message.r') }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item to="download" @click="closeDrawer">
                <v-list-item-title >{{ $t('message.download') }}</v-list-item-title>
          </v-list-item>
          <v-list-item  to="/publication" @click="closeDrawer">
              <v-list-item-title>{{ $t('message.publication') }}</v-list-item-title>
          </v-list-item>
          <v-list-item  to="/user-stats" @click="closeDrawer">
              <v-list-item-title>{{ $t('message.userStats') }}</v-list-item-title>
          </v-list-item>
          <v-list-group value="Version">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
            >{{ $t('message.version') }}</v-list-item>
          </template>
            <v-list-item @click="goToExposomexWebsite">
                <v-list-item-title>{{ $t('message.v1') }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group value="About">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
            >{{ $t('message.About') }}</v-list-item>
          </template>
            <v-list-item  to="/expo" @click="closeDrawer">
                <v-list-item-title >{{ $t('message.ExposomeX') }}</v-list-item-title>
            </v-list-item>
            <v-list-item to="/update-history" @click="closeDrawer">
                <v-list-item-title>{{ $t('message.updateHistory') }}</v-list-item-title>
            </v-list-item>
            <v-list-item to="/people" @click="closeDrawer">
                <v-list-item-title>{{ $t('message.Team') }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list>
      <!-- 导航抽屉内容 -->
    </v-navigation-drawer>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
    };
  },
  name: 'NavigationDrawer',
  computed: {
    ...mapState(['drawer']),
  },
  methods: {
    closeDrawer() {
      // 关闭侧边栏
      this.$store.commit('updateDrawer', false);
    },
    goToExposomexWebsite() {
      const url = 'http://v1.exposomex.cn:80/#/home';
      window.open(url, '_blank', 'noopener,noreferrer');
      this.closeDrawer();
    }
  }
}

</script>

